import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalVariable } from 'app/main/globals'; // Adjust the path if needed
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AspCustomerListService {

  constructor(private http: HttpClient) { }
    getStateList(): Observable<any> {
      console.log('-----Fetching State List-----------');
      return this.http.get(`${GlobalVariable.BASE_API_URL_SPARES}/states/v1/stateList`);
    }

    // createGarageCustomer(param): Observable<any> {
    //   const paramData = param;
    //   paramData['source'] = "web";
      
    
    //   console.log('-------------Create Garage Customer---------------------');
    //   return this.http.post( `${GlobalVariable.BASE_API_URL_SPARES}/garageCustomer/v1/create`,paramData);
    // }

    createGarageCustomer(payload: any): Observable<any> {
      console.log('-------------Create Garage Customer---------------------');
      console.log('Payload:', payload);
    
      return this.http.post(`${GlobalVariable.BASE_API_URL_SPARES}/garageCustomer/v1/customer/create`, payload);
    }

    getAllCustomers(): Observable<any> {
      const garageKey = localStorage.getItem('garageKey');
    
      const body = {
        garageKey: garageKey,
      };
    
      return this.http.post(`${GlobalVariable.BASE_API_URL_SPARES}/garageCustomer/v1/customer/getAll?page=0&size=100`, body, {
      });
    }
    
    getRateCardByGarageKey(garageKey: string): Observable<any> {
  console.log(`-----Fetching Rate Card for Garage Key: ${garageKey}-----`);
  return this.http.get(`https://iapi.testpitstop.com/v1.0/pitstopspare/labour/rateCard/${garageKey}`);
}

}
